import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  tags: {
    '& > *:not(:last-of-type)::after': {
      display: 'inline-block',
      margin: '0 0.75em',
      fontSize: '1em',
      content: '"·"',
      [theme.breakpoints.down('sm')]: {
        margin: '0 0.5em',
      },
    },
  },
  tagspipe: {
    '& > *:not(:last-of-type)::after': {
      display: 'inline-block',
      margin: '0 0.75em',
      fontSize: '1em',
      content: '"|"',
      [theme.breakpoints.down('sm')]: {
        margin: '0 0.5em',
      },
    },
  },
  dense: {
    '& > *:not(:last-of-type)::after': {
      margin: '0 0.35em',
    },
  },
}))
